 <template>
  <div id="showImage">
    <img v-if="this.hasBackgroundImage" id="bg-img" :srcset="this.image"/>
  </div>
</template>

<script>
import axios from 'axios';
import {location} from '../Location'

export default{
  name:'BackgroundImage',

  data(){
    return {
      image:"",
      connections: 0,
      hasBackgroundImage: false,
      }
    },

  async mounted(){
    this.image = await this.getImageFromApi();
    let VueThis = this;
    if(this.hasBackgroundImage){
      document.getElementById('bg-img').ondragstart = function() { return false; }; // dit is om er voor te zorgen dat je niet kan 'slepen' met de afbeelding 
    }
  },

  methods:{
    /** We don't use this anymore, but I like to keep it in for now.
     * 
     */
    async getImage(){ 
      let lo =  location()
      try{
        const newImage = await axios.get(`${lo}getImage`)
        const fullPath = (newImage.data == '' || newImage.data == null ) ? 'uploads/nothing.png' :  `${lo}uploads/${newImage.data}`
        return  fullPath
      } 
      catch(err){
        console.log(err)
        return err
      }

    },

    async getImageFromApi(){
      let room = await axios.get(
        `https://api.enter.hetnieuweinstituut.nl/rooms?slug=${this.$route.params.slug}`
      ).then((res)=>{
        return res.data[0]
      })

      this.hasBackgroundImage = (room.roomoptions[0].upload != null); // set the variable for the background Image
      
      if(room.roomoptions[0].upload == null){
        return null;
      }else{
        return "https://api.enter.hetnieuweinstituut.nl" + room.roomoptions[0].upload.url;
      }



    }
  }, // methods

  sockets: {
    newImg: async function(){
      this.image = await this.getImageFromApi()
      document.getElementById('bg-img').ondragstart = function() { return false; }; // dit is om er voor te zorgen dat je niet kan 'slepen' met de afbeelding 

      // console.log('new image socket')
      }
  }, // sockets

  }

</script>

<style scoped>
#showImage p {
  position:sticky;
  border-bottom: 1px solid black;
  top:0;
  font-size:16px;
  margin-block-start: 0;
  padding:5px;
  background-color:#dbfcf0;
}

#showImage{
/*  position:absolute;*/
}

#showImage img{
  /*  width: 1000px;
  height:auto;
  object-fit: cover;
    height: 1000px;*/

  width: auto;
  height: auto;
  max-width: 1000%;
  min-height: 100%;
  min-width: 100vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 0;

}

</style>
